import { render } from "./EditPurchase.vue?vue&type=template&id=2f3d6c60"
import script from "./EditPurchase.vue?vue&type=script&lang=js"
export * from "./EditPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__